/**
 * TeamSystem Impact - Frontend Score Resolution Utility
 *
 * Catena di priorità: scoreAdjustment > consolidatedScores > scores > 0
 */

import type { IRO } from '../api/iro.api';

export interface EffectiveScores {
  impactScore: number;
  financialScore: number;
  overallScore: number;
  isAdjusted: boolean;
  originalImpactScore: number;
  originalFinancialScore: number;
}

/**
 * Risolve i punteggi effettivi di un IRO secondo la catena di priorità:
 * scoreAdjustment (se active) > consolidatedScores > scores > 0
 */
export function getEffectiveScores(iro: IRO): EffectiveScores {
  // Base scores (without adjustment)
  const originalImpactScore = iro.consolidatedScores?.impactScore ?? iro.scores?.impactScore ?? 0;
  const originalFinancialScore = iro.consolidatedScores?.financialScore ?? iro.scores?.financialScore ?? 0;

  // If adjustment is active, use adjusted values (partial override allowed)
  if (iro.scoreAdjustment?.active) {
    const impactScore = iro.scoreAdjustment.impactScore ?? originalImpactScore;
    const financialScore = iro.scoreAdjustment.financialScore ?? originalFinancialScore;
    return {
      impactScore,
      financialScore,
      overallScore: Math.max(impactScore, financialScore),
      isAdjusted: true,
      originalImpactScore,
      originalFinancialScore,
    };
  }

  return {
    impactScore: originalImpactScore,
    financialScore: originalFinancialScore,
    overallScore: Math.max(originalImpactScore, originalFinancialScore),
    isAdjusted: false,
    originalImpactScore,
    originalFinancialScore,
  };
}
